<template lang="pug">
  .labeled-check-box
    label
      input(
        type="checkbox"
        :value="value"
        :checked="checked"
        :disabled="disabled"
        @change="$emit('change', $event)"
      )
      span {{ title }}
</template>

<style lang="scss" scoped>
.labeled-check-box {
  input {
    display: none;
  }

  label {
    span {
      @extend %input-checkbox-text;
      position: relative;
    }

    span::before {
      content: '';
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      border: 1px solid #999;
      border-radius: 2px;
      margin-right: 12px;
      background-color: rgba(255, 255, 255, 0.2);
    }

    input:checked + span::before {
      background-color: #1faab3;
      border: 1px solid #1faab3;
    }
    input:checked + span::after {
      content: '';
      position: absolute;
      left: 7px;
      top: -2px;
      width: 5px;
      height: 11px;
      transform: rotate(45deg);
      border-bottom: 3px solid #ffffff;
      border-right: 3px solid #ffffff;
    }
  }
}
</style>

<script>
export default {
  props: {
    checked: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    title: { type: String },
    value: { type: String },
  },
  model: {
    prop: 'checked',
    event: 'change',
  },
}
</script>
